import { Add, Edit } from '@carbon/icons-react';
import { DashboardSideNavScreen } from 'component/dashboard';
import { UtilityText } from 'component/text';
// import { TestDatastore } from 'util/testutil';
import { useState } from 'react';
import { CLICK, componentWithVariants, demoFile, story, variant } from 'system/demo';


demoFile('component/dashboard');

const tabs = [
    {
        key: 'tab1',
        label: '!Tab One',
        icon: Add,
        component: () => <UtilityText label='!Tab One' />,
        testID: 'tab-one'
    },
    {
        key: 'tab2',
        label: '!Tab Two',
        icon: Edit,
        component: () => <UtilityText label='!Tab Two' />,
        testID: 'tab-two'
    }
];

const tabsNoIds = [
    {
        key: 'tab3',
        label: '!Tab Three',
        icon: Add,
        component: () => <UtilityText label='!Tab Three' />
    }
];

function DashboardSideNavScreenDemo({selectedTabKey}: {selectedTabKey?: string}) {
    const [tabKey, setTabKey] = useState(selectedTabKey);
    return (
        <DashboardSideNavScreen selectedTabKey={tabKey} />
    );
}

componentWithVariants('DashboardSideNavScreen', DashboardSideNavScreenDemo, {
    config: {
        dashboardTitleLabel: '!Demo Dashboard'
    }
}, [
    variant('Controlled', {
        args: {selectedTabKey: 'tab1'},
        config: {dashboardTabs: tabs}
    }, [story('Switch Tabs', [CLICK('tab-two'), CLICK('tab-one')])]),
    variant('Default Props', {
        config: {dashboardTabs: tabsNoIds}
    })
]);
